import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';

import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { FormControlsModule } from 'form-controls';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { environment } from 'src/environments/environment';
import { AppBaseModule } from '../app-base/app-base.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AuthorizationComponent } from './components/authorization/authorization.component';
import { CreatePasswordComponent } from './components/create-password/create-password.component';
import { DeployPopupComponent } from './components/deploy-popup/deploy-popup.component';
import { ErrorBannerComponent } from './components/error-banner/error-banner.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './components/forgot-username/forgot-username.component';
import { LoginComponent } from './components/login/login.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PrivatePolicyComponent } from './components/register/modals/private-policy/private-policy.component';
import { TermsUseAgreementComponent } from './components/register/modals/terms-use-agreement/terms-use-agreement.component';
import { TutorialComponent } from './components/register/modals/tutorial/tutorial.component';
import { RegisterComponent } from './components/register/register.component';
import { RegisterResolver } from './components/register/register.resolver';
import { ErrorBannerInterceptor } from './interceptors/error-banner.interceptor';
import { RefreshSessionInterceptor } from './interceptors/refresh-session.interceptor';
import { SessionInterceptor } from './interceptors/session.interceptor';
import { AccessRulesService } from './services/access-rules.service';
import { RegisterService } from './services/general/register.service';
import { UserTabsService } from './services/user-tabs.service';
import { SpinnerRectModule } from './shared/components/spinner-rect/spinner-rect.module';
import { ControlsErrorsModule } from './shared/controls-errors.module';
import { ModalLayoutModule } from './shared/modals/modal-layout/modal-layout.module';
import { ModalVideoModule } from './shared/modals/modal-video/modal-video.module';
import { UserRevokeModalModule } from './shared/modals/user-revoke-modal/user-revoke-modal.module';

export function initializeApp(accessRulesService: AccessRulesService) {
  return () => accessRulesService.initialzeLogo();
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotUsernameComponent,
    ForgotPasswordComponent,
    PageNotFoundComponent,
    RegisterComponent,
    PrivatePolicyComponent,
    TermsUseAgreementComponent,
    TutorialComponent,
    CreatePasswordComponent,
    AuthorizationComponent,
    DeployPopupComponent,
    ErrorBannerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppBaseModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormControlsModule.forRoot(environment),
    SimpleNotificationsModule.forRoot({ timeOut: 2500, showProgressBar: false }),
    HttpClientModule,
    SpinnerRectModule,
    ControlsErrorsModule,
    TooltipModule,
    ModalLayoutModule,
    ModalVideoModule,
    UserRevokeModalModule,
    NgxExtendedPdfViewerModule,
  ],
  providers: [
    // https://angular.io/guide/http#interceptor-order
    { provide: HTTP_INTERCEPTORS, useClass: ErrorBannerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RefreshSessionInterceptor, multi: true },
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    RegisterResolver,
    RegisterService,
    AccessRulesService,
    providePrimeNG({
      ripple: false,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AccessRulesService],
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AccessRulesInterceptor,
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(private userTabsSvc: UserTabsService) {
    this.userTabsSvc.destroyPreviousSession();
  }
}
